import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "module/main/util";
var badgeToneClass = {
    blue: "bg-ghostBlue text-primary",
    green: "bg-green/10 text-successText",
    yellow: "bg-warningSoft text-warningText",
    gray: "bg-sherpaSoftMilk text-badgeGray",
    teal: "bg-teal/10 text-badgeTealText",
    red: "bg-dangerSoft text-dangerText",
};
var badgeDotClass = {
    blue: "bg-primary/90",
    green: "bg-successDot",
    yellow: "bg-badgeOrange",
    gray: "bg-badgeGrayDot",
    teal: "bg-badgeTealDot",
    red: "bg-dangerDot",
};
var Badge = function (_a) {
    var children = _a.children, _b = _a.tone, tone = _b === void 0 ? "gray" : _b, className = _a.className, _c = _a.withDot, withDot = _c === void 0 ? false : _c, icon = _a.icon;
    return (_jsxs("span", { className: cx("inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide", badgeToneClass[tone], className), children: [icon ? _jsx("span", { className: "leading-none", children: icon }) : null, withDot ? _jsx("span", { className: cx("h-1.5 w-1.5 rounded-full", badgeDotClass[tone]) }) : null, children] }));
};
export default Badge;
